import { render, staticRenderFns } from "./accommodationsDetails.vue?vue&type=template&id=f2db1456"
import script from "./accommodationsDetails.vue?vue&type=script&lang=js"
export * from "./accommodationsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports